/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Dusty_Bear_CoilInputs */

const en_keen_dusty_bear_coil = /** @type {(inputs: Keen_Dusty_Bear_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Round-specific min answers`)
};

const de_keen_dusty_bear_coil = /** @type {(inputs: Keen_Dusty_Bear_CoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rundenspezifische Mindestantworten`)
};

/**
* | output |
* | --- |
* | "Round-specific min answers" |
*
* @param {Keen_Dusty_Bear_CoilInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_dusty_bear_coil = /** @type {((inputs?: Keen_Dusty_Bear_CoilInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Dusty_Bear_CoilInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_dusty_bear_coil(inputs)
	return de_keen_dusty_bear_coil(inputs)
});